import axios from '../../../../utils/AxiosUtils';
import i18n from '../../../../i18next';
import {
    LOADING,
    LOAD_TENDER_TYPE_MAPPINGS_SUCCESS,
    UPDATE_TENDER_TYPE_MAPPINGS_SUCCESS,
    CLEAR_TENDER_TYPE_MAPPINGS,
    LOAD_POS_TENDER_TYPES_SUCCESS,
    IMPORT_POS_TENDER_TYPES_SUCCESS
} from '../../../types';
import MessageUtils from '../../../../utils/MessageUtils';

export const loadTenderTypeMapping = (restaurantId) => {
    return (dispatch) => {

        if (restaurantId !== undefined && restaurantId !== null && Number(restaurantId) !== -1) {
            dispatch({ type: LOADING, payload: true });

            const url = `/restaurant/${restaurantId}/tender-type-mappings`;

            axios().get(url)
                .then(response => loadTenderTypeMappingSuccess(dispatch, response.data))
                .catch(error => MessageUtils.errorMessageResponse(
                    dispatch, error.response.data, i18n.t('actions:tenderTypeMapping.loadTenderTypeFailure')));
        }

    }
}

const loadTenderTypeMappingSuccess = (dispatch, response) => {
    dispatch({ type: LOADING, payload: false });
    dispatch({ type: LOAD_TENDER_TYPE_MAPPINGS_SUCCESS, payload: response });
}

export const loadPosTenderTypes = (restaurantId, isImport) => {
    return (dispatch) => {

        if (restaurantId !== undefined && restaurantId !== null && Number(restaurantId) !== -1) {
            dispatch({ type: LOADING, payload: true });

            const url = `/restaurant/${restaurantId}/pos-tender-types`;

            axios().get(url)
                .then(response => loadPosTenderTypesSuccess(dispatch, response, isImport))
                .catch(error => MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:tenderTypeMapping.loadPosTenderTypeFailure')));
        }
    }
}

const loadPosTenderTypesSuccess = (dispatch, response, isImport) => {
    dispatch({ type: LOADING, payload: false });
    dispatch({ type: LOAD_POS_TENDER_TYPES_SUCCESS, payload: response.data });

    if (isImport !== undefined && isImport === true) {
        MessageUtils.dispatchSuccessMessage(dispatch, i18n.t('actions:tenderTypeMapping.importPosTenderTypeSuccess'));
    }
}

export const updateTenderTypeMapping = (state, restaurantId) => {
    return (dispatch, getState) => {
        dispatch({ type: LOADING, payload: true });
        const url = `/restaurant/${restaurantId}/tender-type-mappings`;
        const tenderTypeMappings = [];

        state.map(currentMapping => {
            if (currentMapping.posTenderType.id == -1) {
                const sanitizedMapping = {
                    id: currentMapping.id,
                    tenderType: {
                        id: currentMapping.tenderType.id,
                        value: currentMapping.tenderType.value
                    },
                    posTenderType: null
                }
                tenderTypeMappings.push(sanitizedMapping);

            } else {
                tenderTypeMappings.push(currentMapping);
            }
        });

        axios().put(url, tenderTypeMappings)
            .then(response => updateTenderTypeMappingSuccess(dispatch, getState, response))
            .catch(error => MessageUtils.errorMessageResponse(
                dispatch, error.response.data, i18n.t('actions:posSettings.saveFailure')));
    }
}

const updateTenderTypeMappingSuccess = (dispatch, response) => {
    MessageUtils.dispatchSuccessMessage(dispatch, i18n.t('actions:posSettings.saveSuccess'));
    dispatch({ type: LOADING, payload: false });
    dispatch({ type: UPDATE_TENDER_TYPE_MAPPINGS_SUCCESS, payload: response });
}

export const clearTenderTypeMappings = (dispatch) => {
    return (dispatch) => {
        dispatch({ type: CLEAR_TENDER_TYPE_MAPPINGS });
    }
}

export const importPosTenderTypes = (restaurantId) => {
    return (dispatch) => {
        dispatch({ type: LOADING, payload: true });

        const url = `/restaurant/${restaurantId}/import-pos-tender-types`;

        axios().get(url)
            .then(response => importPosTenderTypesSuccess(dispatch, response, restaurantId))
            .catch(error => MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:tenderTypeMapping.loadPosTenderTypeFailure')));
    }
}

const importPosTenderTypesSuccess = (dispatch, response, restaurantId) => {
    dispatch({ type: IMPORT_POS_TENDER_TYPES_SUCCESS, payload: response });

    const url = `/restaurant/${restaurantId}/pos-tender-types`;

    axios().get(url)
        .then(response => loadPosTenderTypesSuccess(dispatch, response, true))
        .catch(error => MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:tenderTypeMapping.loadPosTenderTypeFailure')));
}



// WEBPACK FOOTER //
// ./src/actions/restaurants/settings/pos/TenderTypeMappingAction.js